// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--5-1!./default.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("55609d44", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-slider-component/theme/default.css
// module id = 597
// module chunks = 8